enum DeviceType {
    MOBILE = "MOBILE",
    PC = "PC"
}

export default DeviceType;
